import { useGlotaT } from 'src/hooks/useGlotaTranslation';

function NewOpportunity() {
  const useOpportunitiesText = useGlotaT('spa.details.opportunities.useOpportunities');

  return (
    <div>
      <p>{useOpportunitiesText}</p>
    </div>
  );
}
export default NewOpportunity;
